<template>
  <v-row>
    <v-col cols="6">
      <date-picker label="Sale Date" v-model="data.saleDate"></date-picker>
    </v-col>
    <v-col cols="6">
      <date-picker label="Start Date" v-model="data.startDate"></date-picker>
    </v-col>
    <v-col cols="6">
      <date-picker label="End Date" v-model="data.endDate"></date-picker>
    </v-col>
    <v-col cols="6">
      <select-employee v-model="data.employee_id"></select-employee>
    </v-col>
    <v-col cols="12">
      <v-alert dense outlined type="info">
        Display size and search radius are separate. Add one or more
        suburb-based coverages below.
      </v-alert>
    </v-col>
    <v-col cols="12">
      <select-multi-categories
        v-model="localState.categories"
      ></select-multi-categories>
    </v-col>
    <v-col cols="12" md="4" v-if="showCoverageBuilder">
      <select-suburbs v-model="localState.anchorSuburb"></select-suburbs>
    </v-col>
    <v-col cols="12" md="4" v-if="showCoverageBuilder">
      <v-select
        :items="sizes"
        v-model="localState.size"
        label="Display Size"
      ></v-select>
    </v-col>
    <v-col cols="12" md="4" v-if="showCoverageBuilder">
      <v-select
        :items="radiusOptions"
        item-text="text"
        item-value="value"
        v-model="localState.radiusLevel"
        label="Radius"
      ></v-select>
    </v-col>
    <v-col cols="12" v-if="showCoverageBuilder">
      <v-btn :disabled="!canSaveCoverage" @click="saveCoverage">
        {{ editingIndex !== null ? 'Update coverage' : 'Save coverage' }}
      </v-btn>
    </v-col>
    <v-col cols="12" v-if="data.coverages && data.coverages.length">
      <v-card
        v-for="(coverage, index) in data.coverages"
        :key="`contract-coverage-${index}`"
        class="mb-3"
        outlined
      >
        <v-card-text>
          <v-row>
            <v-col cols="12" md="4">
              <strong>Categories:</strong>
              <div
                v-for="(category, categoryIndex) in coverage.categories"
                :key="`coverage-${index}-category-${categoryIndex}`"
              >
                {{ category }}
              </div>
            </v-col>
            <v-col cols="12" md="3">
              <strong>Anchor Suburb:</strong>
              <div>{{ coverage.anchor_suburb }}</div>
            </v-col>
            <v-col cols="12" md="2">
              <strong>Size:</strong>
              <div>{{ coverage.size }}</div>
            </v-col>
            <v-col cols="12" md="2">
              <strong>Radius:</strong>
              <div>{{ radiusLabelForCoverage(coverage) }}</div>
            </v-col>
            <v-col cols="12" md="1" class="text-right">
              <v-btn icon color="blue" @click="editCoverage(index)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn icon color="red" @click="deleteCoverage(index)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="12">
      <v-file-input
        :loading="data.fileLoading"
        chips
        :clearable="false"
        v-model="data.file"
        label="image"
      ></v-file-input>
    </v-col>
    <v-col cols="12">
      <v-img
        class="rounded-br-lg elevation-5"
        v-if="data.image"
        :src="
          data.image && data.image.includes('storage')
            ? `${baseUrl}${data.image}`
            : `${baseUrl}/storage/${data.image}`
        "
        max-height="300"
        max-width="300"
        contain
      >
        <v-btn @click="deleteFile" width="100%" color="error"
          >Delete
          <v-icon color="white">
            mdi-close
          </v-icon>
        </v-btn>
        <v-progress-linear
          :active="deleteFileLoading"
          color="error"
          absolute
          bottom
          indeterminate
        ></v-progress-linear>
      </v-img>
    </v-col>
    <v-col cols="12">
      <v-switch label="Active" v-model="data.active"></v-switch>
    </v-col>
    <v-col cols="12">
      <v-textarea label="Notes" v-model="data.notes"></v-textarea>
    </v-col>
  </v-row>
</template>

<script>
import SelectMultiCategories from '../../../../components/SelectMultiCategories'
import SelectSuburbs from '../../../../components/SelectSuburbs'
import DatePicker from '../../../../components/DatePicker'
import SelectEmployee from '../../../../components/SelectEmployee'
import { axios, Strings } from '../../../../utils'
export default {
  props: ['data', 'sizes'],
  name: 'ContractForm',
  components: {
    DatePicker,
    SelectMultiCategories,
    SelectSuburbs,
    SelectEmployee
  },
  data() {
    return {
      baseUrl: Strings.baseUrl,
      deleteFileLoading: false,
      editingIndex: null,
      radiusOptions: [
        { text: '10 km tier (100 suburbs)', value: 1 },
        { text: '20 km tier (200 suburbs)', value: 2 },
        { text: '30 km tier (300 suburbs)', value: 3 },
        { text: '40 km tier (395 suburbs)', value: 4 }
      ],
      localState: {
        categories: [],
        anchorSuburb: '',
        size: '',
        radiusLevel: null
      }
    }
  },
  computed: {
    showCoverageBuilder() {
      return this.localState.categories.length > 0
    },
    canSaveCoverage() {
      return (
        this.localState.categories.length > 0 &&
        !!this.localState.anchorSuburb &&
        !!this.localState.size &&
        this.localState.radiusLevel !== null
      )
    }
  },
  methods: {
    saveCoverage() {
      if (!this.canSaveCoverage) {
        return
      }

      const coverage = {
        categories: [...this.localState.categories],
        anchor_suburb: this.localState.anchorSuburb,
        size: this.localState.size,
        radius_level: this.localState.radiusLevel
      }

      if (!Array.isArray(this.data.coverages)) {
        this.$set(this.data, 'coverages', [])
      }

      if (this.editingIndex !== null && this.editingIndex !== undefined) {
        this.data.coverages.splice(this.editingIndex, 1, coverage)
      } else {
        this.data.coverages.push(coverage)
      }

      this.data.categories = []
      this.data.regions = []
      this.data.suburbs = []
      this.data.size = ''
      this.resetCoverageBuilder()
    },
    editCoverage(index) {
      const coverage = Array.isArray(this.data.coverages)
        ? this.data.coverages[index]
        : null
      if (!coverage) {
        return
      }

      this.localState.categories = Array.isArray(coverage.categories)
        ? [...coverage.categories]
        : []
      this.localState.anchorSuburb = coverage.anchor_suburb || ''
      this.localState.size = coverage.size || ''
      this.localState.radiusLevel = this.normalizeRadiusLevel(
        coverage.radius_level !== undefined
          ? coverage.radius_level
          : coverage.radius
      )
      this.editingIndex = index
    },
    deleteCoverage(index) {
      if (!Array.isArray(this.data.coverages)) {
        return
      }

      this.data.coverages.splice(index, 1)
      if (this.editingIndex === index) {
        this.resetCoverageBuilder()
      }
    },
    resetCoverageBuilder() {
      this.localState.categories = []
      this.localState.anchorSuburb = ''
      this.localState.size = ''
      this.localState.radiusLevel = null
      this.editingIndex = null
    },
    normalizeRadiusLevel(value) {
      if (value === null || value === undefined || value === '') {
        return null
      }

      if (!Number.isNaN(Number(value))) {
        const numericValue = Number(value)
        if ([1, 2, 3, 4].includes(numericValue)) {
          return numericValue
        }
      }

      const normalized = `${value}`.toLowerCase().replace(/[\s-]/g, '')
      switch (normalized) {
        case '10':
        case '10km':
        case 'within10km':
        case '5':
        case '5km':
        case 'within5km':
        case '15':
        case '15km':
        case 'within15km':
          return 1
        case '20':
        case '20km':
        case 'within20km':
          return 2
        case '30':
        case '30km':
        case 'within30km':
        case '45':
        case '45km':
        case 'within45km':
          return 3
        case '40':
        case '40km':
        case 'within40km':
        case '60':
        case '60km':
        case 'within60km':
        case 'metro':
        case 'metrowide':
        case 'allmetro':
          return 4
        default:
          return null
      }
    },
    radiusLabelForLevel(radiusLevel) {
      switch (this.normalizeRadiusLevel(radiusLevel)) {
        case 1:
          return 'Within 10km'
        case 2:
          return 'Within 20km'
        case 3:
          return 'Within 30km'
        case 4:
          return 'Within 40km'
        default:
          return ''
      }
    },
    radiusLabelForCoverage(coverage) {
      return this.radiusLabelForLevel(
        coverage.radius_level !== undefined
          ? coverage.radius_level
          : coverage.radius
      )
    },
    deleteFile() {
      this.deleteFileLoading = true
      if (this.data.id) {
        console.log('deleting blog media for id ', this.data.id)
        axios
          .delete(`api/admin/contracts/${this.data.id}/delete-media`)
          .then(res => {
            if (res.data === 1) {
              console.log('done')
              this.data.image = null
              this.deleteFileLoading = false
            }
          })
          .catch(err => console.log(err))
      } else {
        console.log('deleting media for path ', this.data.image)
        axios
          .get(`api/admin/file-delete?path=${this.data.image}`)
          .then(res => {
            if (res.data === 1) {
              console.log('done')
              this.data.image = null
              this.deleteFileLoading = false
            }
          })
          .catch(err => console.log(err))
      }
    }
  }
}
</script>

<style scoped></style>
